import { render, staticRenderFns } from "./LoginOAuth.vue?vue&type=template&id=45a03a81&"
import script from "./LoginOAuth.vue?vue&type=script&lang=js&"
export * from "./LoginOAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports